import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'basket-analysis',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const CustomerInsight = require('./containers/CustomerInsightsContainer').default
      const {customerInsightsFilterReducer, customerInsightsReducer, loadBillFieldsReducer} = require('./modules/customerInsights')
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics')

      injectReducer(store, {key: 'customerInsightsFilter', reducer: customerInsightsFilterReducer})
      injectReducer(store, {key: 'customerInsights', reducer: customerInsightsReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})
      injectReducer(store, {key: 'billFields', reducer: loadBillFieldsReducer})

      /*  Return getComponent   */
      callback(null, CustomerInsight)

      /* Webpack named bundle   */
    }, 'CustomerInsightsView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CustomerInsights/index.js